module.exports = __webpack_public_path__ + "img/innen02.5f86f1cb.jpg";